import { Survey, ScatterPoint } from '../../model/api';

export function sortByAttribute(arr, attribute) {
    return arr.sort(function(a,b) {
        return (a[attribute] < b[attribute]) ? 1 : (a[attribute] > b[attribute]) ? -1 : 0;
    });
}

function getTextByMeanAndStd(lang: string, survey: Survey, y: number, mean: number, std: number) {
    let text = survey.texts[lang].Widgets.OwnResultsScoreTexts.split('|');
    if (y < mean - std) {
        return text[0];
    }
    if (y > mean - std) {
        return text[2];
    }
    return text[1];
}

function getTextByResultRange(lang: string, survey: Survey, y: number) {
    let text = survey.texts[lang].Widgets.OwnResultsScoreTexts.split('|');
    let ranges = survey.texts[lang].Widgets.ResultsRanges;
    for (let i=0 ; i < ranges.length ; i++) {
        if (y >= ranges[i][0] && y <= ranges[i][1]) {
            return text[i];
        }
    }
}

export function bigFive(x: number[]) {
    let [q1,q2,q3,q4,q5,q6,q7,q8,q9,q10] = [...x];

    let extraversion = q1 + (8  - q6);
    let agreeableness = q7 + (8 - q2);
    let conscientiousness = q3 + (8 - q8);
    let stability = q9 + (8 - q4);
    let openness = q5 + (8 - q10);

    let levels = [{'level':'bigfive-extraversion', 'points': extraversion},
                  {'level':'bigfive-agreeableness', 'points': agreeableness },
                  {'level':'bigfive-conscientiousness', 'points': conscientiousness},
                  {'level':'bigfive-stability', 'points': stability},
                  {'level':'bigfive-openness', 'points': openness}];

    let y = [extraversion, agreeableness, conscientiousness, stability, openness];
    let bestMatch = sortByAttribute(levels, 'points')[0].level;

    return { 'y': y, 'bestMatch': bestMatch };
}

export function threeF(x: number[]) {

    let [q1,q2,q3,q4,q5,q6,q7,q8,q9,q10] = [...x];

    let doer = (q1 + q2 + (6 - q3)) / 3;
    let dreamer = (q4 + q5 + q6) / 3 ;
    let believer = (q7 + q8 + q9) / 3;
    let happiness = q10;

    let levels=[{'level':'3f-doer', 'points': doer},
                {'level':'3f-dreamer', 'points': dreamer },
                {'level':'3f-believer', 'points': believer},
                {'level':'3f-happiness', 'points': happiness}];

    let y = [doer, dreamer, believer, happiness];
    let bestMatch = sortByAttribute(levels, 'points')[0].level;

    return { 'y': y, 'bestMatch': bestMatch };
}

export function moralFoundation(x: number[])  {

    let [mf1,mf2,mf3,mf4,mf5,mf7,mf8,mf9,mf10,mf11,mf17,mf18,mf19,mf20,mf21,mf23,mf24,mf25,mf26,mf27] = [...x];

    let care = mf1 + mf7 + mf17 + mf23;
    let fair = mf2 + mf8 + mf18 + mf24;
    let loyalty = mf3 + mf9 + mf19 + mf25;
    let authority = mf4 + mf10 + mf20 + mf26;
    let purity = mf5 + mf11 + mf21 + mf27;

    let levels=[{'level':'mf-care', 'points': care},
                {'level':'mf-fair', 'points': fair },
                {'level':'mf-loyalty', 'points': loyalty},
                {'level':'mf-authority', 'points': authority},
                {'level':'mf-purity', 'points': purity}];


    let y = [care, fair, loyalty, authority, purity];
    let bestMatch = sortByAttribute(levels, 'points')[0].level;

    return { 'y': y, 'bestMatch': bestMatch };
}

export function fakeNews(x: number[])  {

    let [q1,q2,q3,q4,q5,q6,q7,q8] = [...x];
    let y = ((5 -q1) + (5 - q2) + (5 - q3) + q4 + (6 - q5) + q6 + (6 -q7) + (5 - q8));

    return { y };
}

export function art(x : number[]) {

    let [q1,q2,q3,q4,q5,q6] = [...x];

    let y = (q1 + q2 + q3 + q4 + q5 + q6) / 6;

    return { y };
}

export function lifeWork(x: number[])  {

    let [q1,q2,q3,q4,q5,q6] = [...x];

    let y = (q1 + q2 + (6 - q3) + q4 + q5 + q6) / 6;

    return { y };
}

export function partitometro(x: number[])  {

    let [eq1, eq2, fe1, fe2, gov, imm1, imm2, pot, pres, sic, suc, tr1, tr2, ue, univ] = [...x];

    x = [ tr1, tr2, fe1, fe2, imm1, imm2, eq1, eq2, suc, pot, sic, univ, pres, gov, ue];

    let wx: number[] = [0.908030375668787, 0.987633632399048, 0.902129995569227, 0.937270737426711, -0.872254367507232, 0.98324043897986,-0.629290698097671, -0.678484021729118, 0.316879305882864, 0.92736969368567, 0.930422029183613, -0.805863003983494,-0.772978814333193, -0.630010329448491, -0.792197388868114];

    let wy: number[] = [-0.189289598926039,-0.024030132682149,0.229864884268728,0.146732363467913,0.348999576147727,0.011799613322714,-0.744838745898707,-0.528815942886341,0.768069227994776,0.339705541398833,-0.28887677963632,-0.47520534012785,0.598407150792707,0.725148709911155,0.551838161664377];

    let m: number[] = [3.5485520097726, 3.32694923138923, 2.72789804919156, 3.1008967480994, 2.79718014676547, 3.01821148045976, 3.92163130173604, 3.83201364738186, 2.74735732680962, 2.60405495631466, 3.45973542730829, 3.64514629162681, 2.21373815126727, 1.79995818085903, 2.19930964134248];

    let fixX: number[] = [3,3,2,2,5,5,2,2,1,1,1,1,1,1,1];


    let rX = [];
    for (let i=0; i<15; i++){
        rX.push(wx[i]*(x[i]-m[i])*fixX[i]);
    }

    let rYpres = wy[12]*(x[12]-m[12]);

    if(x[12] == 1) {
        rYpres = rYpres*10;
    }


    let rYgov = wy[13]*(x[13]-m[13]);

    if(x[13] == 1) {
        rYgov = rYgov*10;
    }


    let rYue = wy[14]*(x[14]-m[14]);

    if(x[14] == 1) {
        rYue = rYue*10;
    }

    let rY=    [wy[0]*(x[0]-m[0]),
                wy[1]*(x[1]-m[1]),
                wy[2]*(x[2]-m[2]),
                wy[3]*(x[3]-m[3]),
                wy[4]*(x[4]-m[4])*2,
                wy[5]*(x[5]-m[5])*2,
                wy[6]*(x[6]-m[6])*2,
                wy[7]*(x[7]-m[7])*2,
                wy[8]*(x[8]-m[8])*2,
                wy[9]*(x[9]-m[9]),
                wy[10]*(x[10]-m[10]),
                wy[11]*(x[11]-m[11])*2,
                rYpres,
                rYgov,
                rYue
            ];

    let x0 = rX.reduce((a,b) => a+b, 0) / 15;
    let y0 = rY.reduce((a,b) => a+b, 0) / 15;


    let xPD = -1.23716845309642;
    let xLEGA =	1.101;
    let xSINISTRA = -2.001;
    let xM5S =	-0.04834559276989;
    let xFI = 0.40421901657437;
    let xFdI =	0.920596616395224;
    let xDESTRA =	0.922;


    let yPD =	0.099294426300892;
    let yLEGA =	-0.501;
    let ySINISTRA =  -0.311;
    let yM5S =	-0.955;
    let yFI = -0.140727941192889;
    let yFdI =	0.154132714076589;
    let yDESTRA = 0.463582017383125;

    let dpPD = Math.pow(Math.pow(xPD - x0,2) + Math.pow(yPD - y0,2),0.8);
    let dpLEGA = Math.pow(Math.pow(xLEGA - x0,2) + Math.pow(yLEGA - y0,2),0.8);
    let dpSINISTRA = Math.pow(Math.pow(xSINISTRA - x0,2) + Math.pow(ySINISTRA - y0,2),0.8);
    let dpM5S =	Math.pow(Math.pow(xM5S - x0,2) + Math.pow(yM5S - y0,2),0.8);
    let dpFI =	Math.pow(Math.pow(xFI - x0,2) + Math.pow(yFI - y0,2),0.8);
    let dpFdI =	Math.pow(Math.pow(xFdI - x0,2) + Math.pow(yFdI - y0,2),0.8);
    let dpDESTRA = Math.pow(Math.pow(xDESTRA - x0,2) + Math.pow(yDESTRA - y0,2),0.8);

    let dp = dpPD + dpLEGA + dpSINISTRA + dpM5S + dpFI + dpFdI + dpDESTRA;

    let dPD = 1/dp/dpPD;
    let dLEGA = 1/dp/dpLEGA;
    let dSINISTRA = 1/dp/dpSINISTRA;
    let dM5S =	1/dp/dpM5S;
    let dFI = 1/dp/dpFI;
    let dFdI =	1/dp/dpFdI;
    let dDESTRA = 1/dp/dpDESTRA;

    let d = dPD + dLEGA + dSINISTRA + dM5S + dFI + dFdI + dDESTRA;

    let aPD = dPD/d;
    let aLEGA = dLEGA/d;
    let aSINISTRA = dSINISTRA/d;
    let aM5S =	dM5S/d;
    let aFI = dFI/d;
    let aFdI =	dFdI/d;
    let aDESTRA = dDESTRA/d;

    let overlap = '';
    let overlapPercent = 0.9;
    let y = [aPD, aLEGA, aSINISTRA, aM5S, aFI, aFdI, aDESTRA];

    y.forEach(x => {
        if (x >= overlapPercent) {
            overlap = 'overlap';
        }
    });

    let xy: ScatterPoint[] = [{'label': 'pd', 'x': xPD, 'y': yPD},
            {'label': 'lega', 'x': xLEGA, 'y': yLEGA},
            {'label': 'sinistra', 'x': xSINISTRA, 'y': ySINISTRA},
            {'label': 'm5s', 'x': xM5S, 'y': yM5S},
            {'label': 'fi', 'x': xFI, 'y': yFI},
            {'label': 'fdi', 'x': xFdI, 'y': yFdI},
            {'label': 'destra', 'x': xDESTRA, 'y': yDESTRA},
            {'label': 'you', 'x': x0, 'y': y0, 'class': overlap}];

    let affinity = [{'label': 'pd', 'value': aPD },
                {'label': 'lega', 'value':  aLEGA},
                {'label': 'sinistra', 'value': aSINISTRA},
                {'label': 'm5s', 'value': aM5S } ,
                {'label': 'fi', 'value': aFI},
                {'label': 'fdi', 'value': aFdI},
                {'label': 'destra', 'value': aDESTRA}];

    let podium = sortByAttribute(affinity, 'value').slice(0,3);

    let rankings = sortByAttribute(affinity, 'value');


    let tradizionalismo = (tr1 + tr2)/2;
    let libertarismo = (fe1 + fe2)/2;
    let accettazione = (imm1 + 6 - imm2) / 2;
    let egualitarismo = (eq1 + eq2)/2;
    let potenza = pot;
    let universalismo = univ;
    let successo = suc;
    let sicurezza = sic;
    let fiducia = (pres+gov+ue)/3;

    let y1 = [tradizionalismo, libertarismo, accettazione, egualitarismo, potenza, universalismo, successo, sicurezza, fiducia];

    let avgTradizionalismo =3.437751;
    let avgLibertarismo = 2.914397;
    let avgAccettazione = 2.889484;
    let avgEgualitarismo = 3.876822;
    let avgPotenza = 2.604055;
    let avgUniversalismo = 3.645146;
    let avgSuccesso = 2.747357;
    let avgSicurezza = 3.459735;
    let avgFiducia = 2.071002;

    let y2 = [avgTradizionalismo, avgLibertarismo, avgAccettazione, avgEgualitarismo, avgPotenza, avgUniversalismo, avgSuccesso, avgSicurezza, avgFiducia];

    return { 'y': y, 'xy': xy, 'podium': podium, 'rankings': rankings, 'y1': y1, 'y2': y2 };
}

export function europartitometro(x: number[])  {

    // From repubblica example URL
    // http://localhost:8080/it/europartitometro/feed/repubblica?ius=1&ue1=1&ue2=1&min=1&toll=1&tr=1&imm1=1&nat=1&ue3=1&imm2=1&sic=1&op=1&dxsx=1&gov=1&redd=1
    
    let [dxsx, gov, imm1, imm2, ius, min, nat, op, redd, sic, toll, tr, ue1, ue2, ue3] = [...x];

    x = [ius, ue1, ue2, min, toll, tr, imm1, nat, ue3, imm2, sic, op, dxsx, gov, redd];

    //console.log(x);

    let wx: number[] = [
        -0.869161896124557,
        -0.696033145823991,
        -0.767583329839787,
        -0.93542480002175,
        -0.830963135587569,
         0.77436022300893,
         0.881634199400479,
        -0.816550581326006,
         0.851548203257597,
         0.866281670519318,
         0.916128916659223,
        -0.058541277339562,
         0.422017086322485,
         0.63128260284417,
         0.296425073639361
    ];

    let wy: number[] = [
        -0.413129680936013,
        -0.688664193130569,
        -0.583912459399183,
        -0.064303354756776,
        -0.508231369277383,
        0.424304883664908,
        0.347935165141936,
        0.02087712889177,
        0.465992392913144,
        0.431542840845917,
        0.373502838917498,
        0.972136397110655,
        0.802579970286608,
        0.761988566230128,
        0.829013663027135
    ];

    let m: number[] = [
        3.56363599665859,
        3.13818868639502,
        3.57148600161794,
        3.94238758897343,
        4.05943284029033,
        3.28220266387742,
        2.79446767397362,
        3.9610602834195,
        2.48978504786416,
        2.90420081985212,
        3.13848615398927,
        2.80197767382844,
        3.19376831558715,
        2.52461827596469,
        2.89870887129163
    ];

    


    let rX = [];
    for (let i=0; i<15; i++){
        rX.push(wx[i]*(x[i]-m[i])*1.5);        

    }
    

    let rY=    [wy[0]*(x[0]-m[0])*1.5,
                wy[1]*(x[1]-m[1])*1.5,
                wy[2]*(x[2]-m[2])*1.5,
                wy[3]*(x[3]-m[3])*1.5,
                wy[4]*(x[4]-m[4])*1.5,
                wy[5]*(x[5]-m[5])*1.5,
                wy[6]*(x[6]-m[6])*1.5,
                wy[7]*(x[7]-m[7])*1.5,
                wy[8]*(x[8]-m[8])*1.5,
                wy[9]*(x[9]-m[9])*1.5,
                wy[10]*(x[10]-m[10])*1.5,
                wy[11]*(x[11]-m[11])*3,
                wy[12]*(x[12]-m[12])*3,
                wy[13]*(x[13]-m[13])*3,
                wy[14]*(x[14]-m[14])*3
            ];

    let x0 = rX.reduce((a,b) => a+b, 0) / 15;
    let y0 = rY.reduce((a,b) => a+b, 0) / 15;


    let xSINISTRA = -1.493;
    let xPD = -0.708;
    let xPIUEU = -0.414;
    let xVERDI = -1.376;
    let xM5S = 0.098;
    let xFI = 0.485;
    let xFdI = 1.197;
    let xLEGA = 0.902;

    let ySINISTRA = -0.011;
    let yPD = -0.936;
    let yPIUEU = -1.506;
    let yVERDI = 0.337;
    let yM5S = 1.161;
    let yFI = -0.404;
    let yFdI = -0.317;
    let yLEGA = 0.347;

    let dpSINISTRA = Math.pow(Math.pow(xSINISTRA - x0,2) + Math.pow(ySINISTRA - y0,2),0.8);
    let dpPD = Math.pow(Math.pow(xPD - x0,2) + Math.pow(yPD - y0,2),0.8);
    let dpPIUEU = Math.pow(Math.pow(xPIUEU - x0,2) + Math.pow(yPIUEU - y0,2),0.8);
    let dpVERDI = Math.pow(Math.pow(xVERDI - x0,2) + Math.pow(yVERDI - y0,2),0.8);
    let dpM5S =	Math.pow(Math.pow(xM5S - x0,2) + Math.pow(yM5S - y0,2),0.8);
    let dpFI =	Math.pow(Math.pow(xFI - x0,2) + Math.pow(yFI - y0,2),0.8);
    let dpFdI =	Math.pow(Math.pow(xFdI - x0,2) + Math.pow(yFdI - y0,2),0.8);
    let dpLEGA = Math.pow(Math.pow(xLEGA - x0,2) + Math.pow(yLEGA - y0,2),0.8);    
    
    let dp = dpSINISTRA + dpPD + dpPIUEU + dpVERDI + dpM5S + dpFI + dpFdI + dpLEGA;

    //console.log(dpSINISTRA, dpPD, dpPIUEU, dpVERDI, dpM5S, dpFI, dpFdI, dpLEGA);

    //console.log(dp);

    let dSINISTRA = 1/dp/dpSINISTRA;
    let dPD = 1/dp/dpPD;
    let dPIUEU = 1/dp/dpPIUEU;
    let dVERDI = 1/dp/dpVERDI;
    let dM5S =	1/dp/dpM5S;
    let dFI = 1/dp/dpFI;
    let dFdI =	1/dp/dpFdI;
    let dLEGA = 1/dp/dpLEGA;

    let d = dSINISTRA + dPD + dPIUEU + dVERDI + dM5S + dFI + dFdI + dLEGA;

    //console.log(dSINISTRA, dPD, dPIUEU, dVERDI, dM5S, dFI, dFdI, dLEGA);

    //console.log(d);
    
    let aSINISTRA = dSINISTRA/d;
    let aPD = dPD/d;
    let aPIUEU = dPIUEU/d;
    let aVERDI = dVERDI/d;
    let aM5S =	dM5S/d;
    let aFI = dFI/d;
    let aFdI =	dFdI/d;
    let aLEGA = dLEGA/d;
    

    let overlap = '';
    let overlapPercent = 0.9;
    let y = [aSINISTRA, aPD, aPIUEU, aVERDI, aM5S, aFI, aFdI, aLEGA];

    //console.log(y);

    y.forEach(x => {
        if (x >= overlapPercent) {
            overlap = 'overlap';
        }
    });

    let xy: ScatterPoint[] = [
            {'label': 'sinistra', 'x': xSINISTRA, 'y': ySINISTRA},
            {'label': 'pd', 'x': xPD, 'y': yPD},
            {'label': 'piueu', 'x': xPIUEU, 'y': yPIUEU},
            {'label': 'verdi', 'x': xVERDI, 'y': yVERDI},
            {'label': 'm5s', 'x': xM5S, 'y': yM5S},
            {'label': 'fi', 'x': xFI, 'y': yFI},
            {'label': 'fdi', 'x': xFdI, 'y': yFdI},
            {'label': 'lega', 'x': xLEGA, 'y': yLEGA},
            {'label': 'you', 'x': x0, 'y': y0, 'class': overlap}];

    let affinity = [
                {'label': 'sinistra', 'value': aSINISTRA},
                {'label': 'pd', 'value': aPD },
                {'label': 'piueu', 'value': aPIUEU },
                {'label': 'verdi', 'value': aVERDI },
                {'label': 'm5s', 'value': aM5S },
                {'label': 'fi', 'value': aFI},
                {'label': 'fdi', 'value': aFdI},
                {'label': 'lega', 'value':  aLEGA}];

    let rankings = sortByAttribute(affinity, 'value');

    
    return { 'xy': xy, 'y': y, 'rankings': rankings};
}

export function abacusBySurvey(lang: string, survey: Survey, x: number[], stats: any, fbId: number) {

    switch (survey.slug) {
        case 'facebook': {
            return {
                plots: ['radar', 'radar-filters', 'levels'],
                y1: x,
                y2: stats.facebook,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                y2FiltersTitle: {
                    'it': 'Le risposte degli altri',
                    'en': 'Others\' answers'
                },
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': [
                        'Cibo',
                        'Cultura e Spettacolo',
                        'Animali e Natura',
                        'Viaggi',
                        'Sport',
                        'Scienze e Tecnologia',
                        'Politica, Società e Informazione',
                        'Istruzione',
                        'Lavoro',
                        'Shopping',
                        'Salute e Benessere',
                        'Hobby'
                    ],
                    'en': [
                        'Food',
                        'Culture and entertainment',
                        'Animals and nature',
                        'Travel',
                        'Sports',
                        'Science and technology',
                        'Politics, society and information',
                        'Education',
                        'Business',
                        'Shopping',
                        'Health and wellness',
                        'Hobbies'
                    ]
                },
                radarLabels: {
                    'it': [
                        { name: 'Cibo', anchor: 'top'},
                        { name: 'Cultura&nbsp;e<br /> Spettacolo', anchor: 'top'},
                        { name: 'Animali&nbsp;e<br /> Natura', anchor: 'top'},
                        { name: 'Viaggi', anchor: 'top'},
                        { name: 'Sport', anchor: 'bottom'},
                        { name: 'Scienze&nbsp;e<br /> Tecnologia', anchor: 'bottom-right'},
                        { name: 'Politica, Società<br /> e Informazione', anchor: 'bottom'},
                        { name: 'Istruzione', anchor: 'bottom-left'},
                        { name: 'Lavoro', anchor: 'bottom'},
                        { name: 'Shopping', anchor: 'top'},
                        { name: 'Salute&nbsp;e<br /> Benessere', anchor: 'top'},
                        { name: 'Hobby', anchor: 'top'}
                    ],
                    'en': [
                        { name: 'Food', anchor: 'top'},
                        { name: 'Culture&nbsp;and<br /> entertainment', anchor: 'top'},
                        { name: 'Animals&nbsp;and<br /> nature', anchor: 'top'},
                        { name: 'Travel', anchor: 'top'},
                        { name: 'Sports', anchor: 'bottom'},
                        { name: 'Science&nbsp;and<br /> technology', anchor: 'bottom-right'},
                        { name: 'Politics, society<br /> and information', anchor: 'bottom'},
                        { name: 'Education', anchor: 'bottom-left'},
                        { name: 'Business', anchor: 'bottom'},
                        { name: 'Shopping', anchor: 'top'},
                        { name: 'Health&nbsp;and<br /> wellness', anchor: 'top'},
                        { name: 'Hobbies', anchor: 'top'}
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(163,138,124)',
                    'rgb(253,103,84)',
                    'rgb(113,131,41)',
                    'rgb(84,171,174)',
                    'rgb(252,160,45)',
                    'rgb(122,152,151)',
                    'rgb(106,181,252)',
                    'rgb(57,182,173)',
                    'rgb(253,137,114)',
                    'rgb(254,201,68)',
                    'rgb(157,157,156)'
                ],
                ageFilter: {
                    'it': {
                        title: 'Età',
                        ageRange1: '18-24',
                        ageRange2: '24-29',
                        ageRange3: '30+'
                    },
                    'en': {
                        title: 'Age',
                        ageRange1: '18-24',
                        ageRange2: '24-29',
                        ageRange3: '30+'
                    }
                },
                genderFilter: {
                    'it': {
                        title: 'Sesso',
                        gender1: 'Maschio',
                        gender2: 'Femmina'
                    },
                    'en': {
                        title: 'Gender',
                        gender1: 'Male',
                        gender2: 'Female'
                    }
                },

                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: 5,
                levelsPaddingLeft: 275,
                levelsRowHeight: 35
            }
        }

        case 'moral-foundations': {
            let r = moralFoundation(x);
            let o = moralFoundation(stats.median);
            return {
                plots: ['radar', 'levels'],
                y1: r.y,
                y2: o.y,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                scoreDescription: survey.texts[lang].Widgets['OwnResultsText:' + r.bestMatch],
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': ['Cura', 'Equità', 'Lealtà', 'Rispetto','Purezza'],
                    'en': ['Care', 'Fairness', 'Loyalty', 'Authority', 'Purity']
                },
                radarLabels: {
                    'it': [
                        { name: 'Cura', anchor: 'top' },
                        { name: 'Equità', anchor: 'top' },
                        { name: 'Lealtà', anchor: 'bottom' },
                        { name: 'Rispetto', anchor: 'bottom' },
                        { name: 'Purezza', anchor: 'top' }
                    ],
                    'en': [
                        { name: 'Care', anchor: 'top' },
                        { name: 'Fairness', anchor: 'top' },
                        { name: 'Loyalty', anchor: 'bottom' },
                        { name: 'Authority', anchor: 'bottom' },
                        { name: 'Purity', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(253,137,114)',
                    'rgb(113,131,41)',
                    'rgb(254,201,68)',
                    'rgb(57,182,173)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: 30,
                levelsRangeLabels: ['0','30'],
                levelsPaddingLeft: 100
            }
        }

        case 'bigfive': {
            let r = bigFive(x);
            let o = bigFive(stats.median);
            return {
                plots: ['radar', 'levels'],
                y1: r.y,
                y2: o.y,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                scoreDescription: survey.texts[lang].Widgets['OwnResultsText:' + r.bestMatch],
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': ['Estroversione', 'Amicalità', 'Affidabilità', 'Stabilità emotiva', 'Disponibile a nuove esperienze'],
                    'en': ['Extraversion', 'Agreeableness', 'Conscientiousness', 'Emotional stability', 'Openness to experience']
                },
                radarLabels: {
                    'it': [
                        { name: 'Estroversione', anchor: 'top' },
                        { name: 'Amicalità', anchor: 'top' },
                        { name: 'Affidabilità', anchor: 'bottom' },
                        { name: 'Stabilità emotiva', anchor: 'bottom' },
                        { name: 'Disponibile<br /> a nuove<br /> esperienze', anchor: 'top' }
                    ],
                    'en': [
                        { name: 'Extraversion', anchor: 'top' },
                        { name: 'Agreeableness', anchor: 'top' },
                        { name: 'Conscientiousness', anchor: 'bottom' },
                        { name: 'Emotional stability', anchor: 'bottom' },
                        { name: 'Openness<br /> to experience', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(253,137,114)',
                    'rgb(113,131,41)',
                    'rgb(254,201,68)',
                    'rgb(57,182,173)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: Math.max(...r.y, ...o.y),
                levelsPaddingLeft: 268
            }
        }

        case '3f': {
            let r = threeF(x);
            let o = threeF(stats.median);
            return {
                plots: ['radar', 'levels'],
                y1: r.y,
                y2: o.y,
                y1Title: survey.texts[lang].Widgets.OwnResultsLegend,
                y2Title: survey.texts[lang].Widgets.OthersResultsLegend,
                scoreDescription: survey.texts[lang].Widgets['OwnResultsText:' + r.bestMatch],
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                yLabels: {
                    'it': ['Fare', 'Fiducia', 'Futuro', 'Felicità'],
                    'en': ['Doer', 'Dreamer', 'Believer', 'Happiness']
                },
                radarLabels: {
                    'it': [
                        { name: 'Fare', anchor: 'top' },
                        { name: 'Fiducia', anchor: 'top' },
                        { name: 'Futuro', anchor: 'bottom' },
                        { name: 'Felicità', anchor: 'top' }
                    ],
                    'en': [
                        { name: 'Doer', anchor: 'top' },
                        { name: 'Dreamer', anchor: 'top' },
                        { name: 'Believer', anchor: 'bottom' },
                        { name: 'Happiness', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(253,137,114)',
                    'rgb(113,131,41)',
                    'rgb(254,201,68)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: Math.max(...r.y, ...o.y),
                levelsPaddingLeft: 110
            }
        }

        case 'life-work': {
            let r = lifeWork(x);
            return {
                plots: ['image'],
                y1: r.y,
                scoreTitle: survey.texts[lang].Widgets.OwnResultsLegend + ' ' + r.y.toFixed(1),
                scoreDescription: getTextByMeanAndStd(lang, survey, r.y, lifeWork(stats.mean).y, lifeWork(stats.std).y),
                image: survey.themeParameters.ResultsImageName
            }
        }

        case 'art': {
            let r = art(x);
            return {
                plots: ['image'],
                y1: r.y,
                scoreTitle: survey.texts[lang].Widgets.OwnResultsLegend + ' ' + r.y.toFixed(1),
                scoreDescription: getTextByMeanAndStd(lang, survey, r.y, art(stats.mean).y, art(stats.std).y),
                image: survey.themeParameters.ResultsImageName
            }
        }

        case 'fake-news': {
            let r = fakeNews(x);
            return {
                plots: ['image'],
                y1: r.y,
                scoreTitle: survey.texts[lang].Widgets.OwnResultsLegend + ' ' + r.y.toFixed(0) + ' su 36',
                scoreDescription: getTextByResultRange(lang, survey, r.y),
                image: survey.themeParameters.ResultsImageName
            }
        }

        case 'partitometro': {
            let r = partitometro(x);
            let rankingsLabels = [];

            r.xy.forEach( x => {
                    if (x.label == 'you') {
                        x.markerUrl = `https://graph.facebook.com/${fbId}/picture?type=large`
                    }
                    else {
                        x.markerUrl = `/_assets/resources/surveys/partitometro/${x.label}.png`
                    }
                }
            );

            r.rankings.forEach( x => {
                x.value = (x.value * 100).toFixed(2);
                x.markerUrl = `/_assets/resources/surveys/partitometro/${x.label}.png`;
            });

            return {
                plots: ['rankings', 'scatter', 'podium', 'radar','levels'],
                y1: r.y1,
                y2: r.y2,
                xy: r.xy,
                y1Title: 'Le tue risposte',
                y2Title: 'Le risposte degli altri',
                scoreDescription: 'E infine, ecco chi sei e quali i tratti valoriali che ti contraddistinguono. Confrontati con gli altri rispondenti! Se vuoi saperne di più su ogni tratto, <a class="survey-info-link-inline" href="/it/partitometro/affinita">clicca qui.</a>',
                scatterDescription: 'Ecco il tuo posizionamento nella mappa di tutti i partiti. L’asse orizzontale indica lo spettro politico da sinistra a destra, l’asse verticale riflette la fiducia verso le istituzioni.',
                rankingsDescription: 'Qual è la tua percentuale di affinità con ogni partito?<br/><br/><br/>',
                podiumDescription: 'Ecco il podio dei 3 partiti più affini al tuo profilo di risposta.<br/><br/><br/>',
                note: '* Il simbolo di Liberi e Uguali indica il posizionamento degli elettori di LeU ma anche degli altri partiti di sinistra.',
                y1LegendColor: 'rgba(73,212,176,0.5)',
                y2LegendColor: 'rgba(254,196,82,0.5)',
                rankingLabels: [
                    'PD',
                    'LEGA',
                    'SINISTRA',
                    'M5S',
                    'FI',
                    'FDI',
                    'DESTRA'
                ],
                yLabels: {
                    'it': [
                        'Tradizionalismo',
                        'Libertarismo',
                        'Accettazione',
                        'Egualitarismo',
                        'Potenza',
                        'Universalismo',
                        'Successo',
                        'Sicurezza',
                        'Fiducia'
                    ]
                },
                radarLabels: {
                    'it': [
                        { name: 'Tradizionalismo', anchor: 'top' },
                        { name: 'Libertarismo', anchor: 'top' },
                        { name: 'Accettazione', anchor: 'top' },
                        { name: 'Egualitarismo', anchor: 'bottom' },
                        { name: 'Potenza', anchor: 'bottom' },
                        { name: 'Universalismo', anchor: 'bottom' },
                        { name: 'Successo', anchor: 'bottom' },
                        { name: 'Sicurezza', anchor: 'top' },
                        { name: 'Fiducia', anchor: 'top' }
                    ]
                },
                radarShapeColors: [
                    'rgba(254,196,82,0.5)',
                    'rgba(73,212,176,0.5)'
                ],
                radarLabelColors: [
                    'rgb(37,116,226)',
                    'rgb(163,138,124)',
                    'rgb(253,103,84)',
                    'rgb(113,131,41)',
                    'rgb(84,171,174)',
                    'rgb(252,160,45)',
                    'rgb(106,181,252)',
                    'rgb(57,182,173)',
                    'rgb(253,137,114)'
                ],
                levelsLineColors: [
                    'rgb(254,196,82)',
                    'rgb(73,212,176)'
                ],
                levelsRangeMin: 0,
                levelsRangeMax: 5,
                levelsRangeLabels: ['0','5'],
                levelsPaddingLeft: 150,
                levelsRowHeight: 40,
                scatterBg: 'rgba(240, 191, 155,0.2)',
                scatterLink: 'partitometro-info',
                barChartHorizontalBg: 'rgba(240, 191, 155,0.2)',
                barChartHorizontalBarColor: 'rgb(254,196,82)',
                rankings: r.rankings,
                podium: r.podium,
                podiumBgColors: [
                   'rgba(240,191,155,0.5)',
                   'rgba(240,191,155,0.4)',
                   'rgba(240,191,155,0.3)'
                ],
                podiumLabelsColor: 'rgb(229,158,109)'
            };
        }

        case 'europartitometro': {
            let r = europartitometro(x);            

            r.xy.forEach( x => {
                    if (x.label == 'you') {
                        x.markerUrl = `https://graph.facebook.com/${fbId}/picture?type=large`;
                    }
                    else {
                        x.markerUrl = `/_assets/resources/surveys/europartitometro/${x.label}.png`;
                    }
                }
            );

            r.rankings.forEach( x => {
                x.value = (x.value * 100).toFixed(2);
                x.markerUrl = `/_assets/resources/surveys/europartitometro/${x.label}.png`;
            });

            return {
                plots: ['scatter', 'rankings'],
                xy: r.xy,
                scatterDescription: 'Ecco il tuo posizionamento nella mappa di tutti i partiti.',
                rankingsDescription: 'Qual è la tua percentuale di affinità con ogni partito?',
                rankingLabels: [
                    'SINISTRA',
                    'PD',
                    'PIUEU',
                    'VERDI',
                    'M5S',
                    'FI',
                    'FDI',
                    'LEGA'
                ],
                scatterBg: '#F2F5F9',
                scatterLink: 'europartitometro-info',
                barChartHorizontalBg: '#F2F5F9',
                barChartHorizontalBarColor: '#FFD617',
                rankings: r.rankings
            };
        }

        default:
            return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/surveys/abacus.ts